import { render, staticRenderFns } from "./Detail-Invoice.vue?vue&type=template&id=730b682f"
import script from "./Detail-Invoice.vue?vue&type=script&lang=js"
export * from "./Detail-Invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports